var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAccountType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1814_122971)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.551 24.2798C28.1826 24.2798 31.8295 22.3104 31.8295 19.7576C31.8295 17.2047 28.1826 15.1625 23.551 15.1625C18.9194 15.1625 15.1631 17.2412 15.1631 19.7576C15.1631 22.274 18.8829 24.2798 23.551 24.2798Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1631 32.0843V33.3242C15.1631 35.8406 18.8829 37.8464 23.551 37.8464C23.8063 37.8464 24.0616 37.8099 24.3168 37.8099C23.7333 36.8982 23.2957 35.9135 23.0404 34.8195C19.6853 34.71 16.7677 33.6889 15.1631 32.0843Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8216 33.2877C22.8216 33.0689 22.7851 32.8136 22.7851 32.5584C22.7851 31.7925 22.8945 31.0266 23.0769 30.2973C19.6853 30.1879 16.8042 29.1667 15.1631 27.5621V28.802C15.1631 31.209 18.5182 33.0689 22.8216 33.2877Z",
    fill: "#1D1B18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.551 28.802C24.0616 27.5985 24.7545 26.5409 25.6662 25.6657C24.9733 25.7386 24.2804 25.7751 23.551 25.7751C19.977 25.7751 16.8771 24.7175 15.1631 23.0399V24.2798C15.1631 26.8327 18.8829 28.802 23.551 28.802Z",
    fill: "#1D1B18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.838 32.5589C40.838 37.131 37.1316 40.8374 32.5595 40.8374C27.9874 40.8374 24.281 37.131 24.281 32.5589C24.281 27.9868 27.9874 24.2804 32.5595 24.2804C37.1316 24.2804 40.838 27.9868 40.838 32.5589ZM32.6508 27.1175C32.9251 27.1175 33.1995 27.3919 33.1995 27.6662V28.3064H34.8456C35.12 28.3064 35.3943 28.5807 35.3943 28.8551V29.038C35.3943 29.3124 35.12 29.5867 34.8456 29.5867H31.279C31.0046 29.5867 30.7303 29.7696 30.5474 29.9525C30.273 30.2269 30.1816 30.5012 30.1816 30.7756C30.1816 31.0499 30.3645 31.3243 30.5474 31.5072C30.7303 31.6901 31.0046 31.873 31.279 31.873H33.7482C34.3883 31.873 35.0495 32.0836 35.5321 32.5868C35.9419 33.0142 36.2174 33.6106 36.2174 34.2508C36.2174 34.8909 36.0345 35.4396 35.6687 35.8969C35.3029 36.3541 34.6627 36.6285 34.0225 36.6285H33.3824V37.4516C33.3824 37.7259 33.108 38.0003 32.8337 38.0003H32.5593C32.285 38.0003 32.0106 37.7259 32.0106 37.4516V36.6285H29.9987C29.7243 36.6285 29.4499 36.3541 29.4499 36.0798V35.8054C29.4499 35.5311 29.6329 35.3482 29.9072 35.3482H33.7482C34.114 35.3482 34.3883 35.2567 34.5712 35.1653C34.8456 34.8909 34.9371 34.6166 34.9371 34.3422C34.9371 33.9764 34.7541 33.702 34.5712 33.5191C34.2969 33.2448 34.0225 33.1533 33.7482 33.1533H31.279C30.7303 33.1533 30.0901 32.879 29.6329 32.4217C29.1756 32.0559 28.9012 31.4158 28.9012 30.7756C28.9012 30.1354 29.1756 29.4953 29.6329 29.1295C29.9987 28.6722 30.6388 28.3978 31.279 28.3978H31.9191V27.6662C31.9191 27.3919 32.102 27.1175 32.3764 27.1175H32.6508Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1814_122971",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAccountType);
export default __webpack_public_path__ + "static/media/Home_Account_Type.d55d0b18c4c477172a1e9189b51e22ec.svg";
export { ForwardRef as ReactComponent };